import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, state } = useLocation();

  useEffect(() => {
    // Some navigations are the "same page, different URL" kind — e.g. the
    // guide's language switch, which swaps fr <-> en routes. Jumping to the top
    // there would lose the reader's place mid-article.
    if ((state as { preserveScroll?: boolean } | null)?.preserveScroll) return;

    window.scrollTo({ top: 0, left: 0 });
    // Also reset any scrollable container, just in case
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, state]);

  return null;
};

export default ScrollToTop;
